import options from '@/utils/options'

const user = {
  state: {
    // 时间间隔options
   ...options
  },

  mutations: {},

  actions: {}
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/options.js